module.exports = __webpack_public_path__ + "static/img/05.607487c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/app/05.png
// module id = LTug
// module chunks = 0